import { render, staticRenderFns } from "./numberTextField.vue?vue&type=template&id=0883357c&scoped=true"
import script from "./numberTextField.vue?vue&type=script&lang=js"
export * from "./numberTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0883357c",
  null
  
)

export default component.exports